import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'

import {
  Table,
  Divider,
  Collapse,
  Row,
  Col,
  Form,
  message,
  Tabs,
  Spin,
  Card
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import ProductImg from '../../../assets/images/product-details.png'
import { useHistory } from 'react-router-dom'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { REPORT_STORE_CREDIT } from '../../../constants/Pages'
import {
  checkRightspermissions,
  formatDigits,
  isEmptyObject,
  notAllowMsgCheck,
  parseFloatCustom,
  verifyPkgFeature
} from '../../../appRedux/actions'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'
const Panel = Collapse.Panel
const TabPane = Tabs.TabPane

const viewByOptions = [
  { label: 'Day', value: 'Day' },
  { label: 'Week', value: 'Week' },
  { label: 'Month', value: 'Month ' }
]

const StoreCreditReportsListing = ({ match }) => {
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )

  const [isLoading, setIsLoading] = React.useState(true)
  const [data, setData] = useState({})
  const [decimal, setDecimal] = useState(2)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  React.useEffect(() => {
    if (!verifyPkgFeature(PkgFeatures.ReportingAndAnalytics)) {
      setIsFeatureAllowed(false)
    }

    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'report.store.credit')
    }

    getStoreCreditService({}, PkgFeatures.ReportingAndAnalytics)
    dispatch(setCommonConfigs(REPORT_STORE_CREDIT))
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    const commonData = getReduxCommonSetting
    if (
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.currencyData
    ) {
      let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData
      // setCurrSymbol(currencyData.currencySymbol);
      // setShortCurr(currencyData.currencyCode);
      setCurrData(currencyData)
    }

    // rights && permissions
    if (commonData && commonData.storeCommonConfigs) {
      const rpData = checkRightspermissions(commonData)
      if (rpData && !isEmptyObject(rpData)) {
        setupRightsPermissions(rpData)
        setAccessLoading(false)
      } else {
        toInitialState()
        setAccessLoading(false)
      }
    }
  }, [getReduxCommonSetting])

  function setupRightsPermissions (rpData) {
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
  }

  function toInitialState () {
    setIsAllowRead(false)
  }

  async function getStoreCreditService (body, featureID) {
    const resp = ds.getReportsStoreCredit(body, BEHAVIOUR_TYPE.GET, featureID)
    await resp
      .then(res => {
        setIsLoading(false)
        if (res && !isEmptyObject(res)) {
          let cusReports = []
          if (res.cusReports && res.cusReports.length > 0) {
            cusReports = res.cusReports.map(a => {
              return {
                balance: formatDigits(a.balance, decimal),
                customerID: a.customerID,
                logID: a.logID,
                totalIssued: formatDigits(a.totalIssued, decimal),
                totalRedeemed: formatDigits(a.totalRedeemed, decimal),
                userName: a.userName
              }
            })
          }
          const da = {
            balance: formatDigits(res.balance, decimal),
            cusReports: cusReports,
            totalIssued: formatDigits(res.totalIssued, decimal),
            totalRedeemed: formatDigits(res.totalRedeemed, decimal)
          }
          setData(da)
        } else setData({})
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
        setData({})
      })
  }

  const columns = [
    {
      title: <IntlMessages id='reporting.storecreditreports.customer' />,
      dataIndex: 'userName',
      dataIndex: 'userName'
    },
    {
      title: <IntlMessages id='reporting.storecreditreports.totalissued' />,
      dataIndex: 'totalIssued',
      key: 'totalIssued'
    },
    {
      title: <IntlMessages id='reporting.storecreditreports.totalredeeemed' />,
      dataIndex: 'totalRedeemed',
      key: 'totalRedeemed'
    },
    {
      title: <IntlMessages id='reporting.storecreditreports.balance' />,
      dataIndex: 'balance',
      key: 'balance'
    }
  ]

  //Main Return
  return getIsAllowRead && isFeatureAllowed ? (
    <div className='Content-wrapper StoreCreditReports-pg'>
      <Spin
        tip={<IntlMessages id='sell.cashlisting.cashloading' />}
        spinning={isLoading}
        size='large'
      >
        <Row>
          <Col md={24}>
            <h1 className=''>
              <IntlMessages id='reporting.storecreditreports.storecreditreports' />
            </h1>
          </Col>
        </Row>

        <Card className='dk-billing-card billing-card-md'>
          <Card.Grid
            className='dk-text-one-line dk-billing-card-pd'
            hoverable={false}
          >
            <strong>
              <IntlMessages id='reporting.storecreditreports.totalvaluedissued' />
            </strong>
          </Card.Grid>{' '}
          <Card.Grid hoverable={false} className='dk-billing-card-pd'>
            {' '}
            {getCurrData.currencyCode
              ? getCurrData.currencyCode
              : getCurrData.currencySymbol
              ? getCurrData.currencySymbol
              : getCurrData.currencyName}{' '}
            {data && data.totalIssued
              ? formatDigits(data.totalIssued, getDecimalPlaces)
              : '0.00'}
          </Card.Grid>
          <Card.Grid
            className='dk-text-one-line dk-billing-card-pd'
            hoverable={false}
          >
            <strong>
              <IntlMessages id='reporting.storecreditreports.totalvalueredeemed' />
            </strong>
          </Card.Grid>{' '}
          <Card.Grid hoverable={false} className='dk-billing-card-pd'>
            {getCurrData.currencyCode
              ? getCurrData.currencyCode
              : getCurrData.currencySymbol
              ? getCurrData.currencySymbol
              : getCurrData.currencyName}{' '}
            {data && data.totalRedeemed
              ? formatDigits(data.totalRedeemed, getDecimalPlaces)
              : '0.00'}
          </Card.Grid>
          <Card.Grid
            className='dk-text-one-line dk-billing-card-pd'
            hoverable={false}
          >
            <strong>
              <IntlMessages id='reporting.storecreditreports.outstandingbalance' />
            </strong>
          </Card.Grid>{' '}
          <Card.Grid hoverable={false} className='dk-billing-card-pd'>
            {' '}
            {getCurrData.currencyCode
              ? getCurrData.currencyCode
              : getCurrData.currencySymbol
              ? getCurrData.currencySymbol
              : getCurrData.currencyName}{' '}
            {data && data.balance
              ? formatDigits(data.balance, getDecimalPlaces)
              : '0.00'}
          </Card.Grid>
        </Card>

        <Table
          className='gx-table-responsive'
          columns={columns}
          dataSource={
            data && data.cusReports && data.cusReports.length > 0
              ? data.cusReports
              : []
          }
        />
      </Spin>
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default StoreCreditReportsListing
